/**
 * Discount Popup trigger - Klaviyo-bridge variant.
 *
 * The floating circle stays in-theme so we keep the brand UX (sparkle, pink,
 * dismiss X). When clicked it opens a Klaviyo-native form by its form ID,
 * which is supplied via the trigger's data-klaviyo-form-id attribute.
 *
 * Persistence:
 *   - localStorage 'rb-discount-subscribed' (permanent) — set when Klaviyo
 *     reports a successful submit; trigger hides forever for that browser.
 *   - sessionStorage 'rb-discount-dismissed' — set when the user clicks the
 *     X on the circle; trigger hides for the rest of the session.
 */
(function () {
  var SUBSCRIBED_KEY = 'rb-discount-subscribed';
  var DISMISSED_KEY = 'rb-discount-dismissed';

  if (localStorage.getItem(SUBSCRIBED_KEY)) return;
  if (sessionStorage.getItem(DISMISSED_KEY)) return;

  var trigger = document.getElementById('rb-discount-trigger');
  if (!trigger) return;

  var formId = trigger.getAttribute('data-klaviyo-form-id');
  if (!formId) return;

  var dismissBtn = trigger.querySelector('.rb-discount-trigger__close');

  // Reveal the trigger
  trigger.removeAttribute('hidden');

  function openKlaviyoForm() {
    // Klaviyo's canonical onsite API for opening a specific form ID.
    // The queue is processed when the onsite SDK finishes loading, so
    // calling before SDK ready is safe.
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
    // Modern unified namespace — try both for forward-compat.
    if (typeof window.klaviyo === 'object' && typeof window.klaviyo.openForm === 'function') {
      try { window.klaviyo.openForm(formId); } catch (_) {}
    }
  }

  function dismissTrigger(e) {
    e.stopPropagation();
    trigger.setAttribute('hidden', '');
    sessionStorage.setItem(DISMISSED_KEY, '1');
  }

  trigger.addEventListener('click', function (e) {
    if (e.target.closest('.rb-discount-trigger__close')) return;
    openKlaviyoForm();
  });

  if (dismissBtn) {
    dismissBtn.addEventListener('click', dismissTrigger);
  }

  // Klaviyo dispatches a `klaviyoForms` document event on form interactions.
  // Persist the "subscribed" flag when our targeted form is submitted so the
  // trigger never re-appears for that browser.
  document.addEventListener('klaviyoForms', function (e) {
    if (!e || !e.detail) return;
    if (e.detail.formId !== formId) return;
    if (e.detail.type === 'submit') {
      localStorage.setItem(SUBSCRIBED_KEY, '1');
      trigger.setAttribute('hidden', '');
    }
  });
})();
